const es = global.es;

export default class ColorPerFeatureStyler {
    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo) {
        if (feature.attrs['ES_STYLE_COLOR'] == null) {
            return styler.defaultStyle;
        }
        
        var defColor = es.api.style.getMainColor(styler.defaultStyle);
        var alpha = es.util.color.getAlpha(defColor);
        var color = es.util.color.withAlpha(feature.attrs['ES_STYLE_COLOR'], alpha);
        
        return es.api.style.withColor(styler.defaultStyle, color);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler): number[] {
        return es.util.style.types[styler.defaultStyle.$type].getPaddingPx(styler.defaultStyle);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler) {
        return es.util.style.types[styler.defaultStyle.$type].hasDirect(styler.defaultStyle);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler) {
        return es.util.style.types[styler.defaultStyle.$type].hasOverlays(styler.defaultStyle);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        return null;
    }
}
